<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab>納入指示者設定</v-tab>
      <v-tab-item>
        <v-card class="mt-2">
          <v-card-title>納入指示者設定</v-card-title>
          <v-card-actions>
            <v-flex md1 sm6 xs12><v-btn @click="create">行追加</v-btn></v-flex>
            <v-flex md1 sm6 xs12>
              <v-btn :disabled="selected.length !== 1" @click="edit"
                >編集</v-btn
              ></v-flex
            >
            <v-flex md1 sm6 xs12>
              <v-btn :disabled="selected.length !== 1" @click="remove">{{
                $t("app.buttons.remove")
              }}</v-btn></v-flex
            >
            <v-flex md2 sm6 xs12>
              <v-btn @click="downloadDD">excel出力</v-btn>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="事業本部"
                url="/divisions/kv?type=BU"
                v-model="buId"
              />
            </v-flex>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="showDeliveryDirectors"
            :rows-per-page-items="[10]"
            class="elevation-0"
            item-key="key"
            select-all
            v-model="selected"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{
                  props.item.buCode === null
                    ? ""
                    : props.item.buCode + ":" + props.item.buName
                }}
              </td>
              <td>
                {{
                  props.item.departmentCode === null
                    ? ""
                    : props.item.departmentCode +
                      ":" +
                      props.item.departmentName
                }}
              </td>

              <td>{{ props.item.productName }}</td>
              <td>
                {{
                  props.item.classificationName == null
                    ? classificationMapper(props.item.classificationId)
                    : props.item.classificationName
                }}
              </td>
              <td>{{ props.item.deliveryDirectorName1 }}</td>
              <td>{{ props.item.deliveryDirectorName2 }}</td>
              <td>{{ props.item.deliveryDirectorName3 }}</td>
              <td>{{ props.item.deliveryDirectorName4 }}</td>
              <td>{{ props.item.deliveryDirectorName5 }}</td>
              <td>{{ props.item.deliveryDirectorName6 }}</td>
              <td>{{ props.item.deliveryDirectorName7 }}</td>
              <td>{{ props.item.deliveryDirectorName8 }}</td>
            </template>
          </v-data-table>
          <sharp-dialog
            :accRepeat="accRepeatFunc('Delivery_Director')"
            :companyId="company.companyId"
            @refresh="saved()"
            ref="sharp"
          ></sharp-dialog>
          <sharp-edit
            :acc="selected[0]"
            :accRepeat="accRepeatFunc('Delivery_Director', selected[0])"
            :companyId="company.companyId"
            @edit="edit"
            @refresh="saved()"
            ref="edit"
          ></sharp-edit>
        </v-card>
      </v-tab-item>
      <v-tab>BL確認者設定</v-tab>
      <v-tab-item>
        <v-card class="mt-2">
          <v-card-title>B/L確認者設定</v-card-title>
          <v-card-actions>
            <v-flex md1 sm6 xs12>
              <v-btn @click="createBl">行追加</v-btn></v-flex
            >
            <v-flex md1 sm6 xs12>
              <v-btn :disabled="blSelected.length !== 1" @click="editBl"
                >編集</v-btn
              >
            </v-flex>
            <v-flex md1 sm6 xs12>
              <v-btn :disabled="blSelected.length !== 1" @click="removeBl">{{
                $t("app.buttons.remove")
              }}</v-btn>
            </v-flex>

            <v-flex md2 sm6 xs12>
              <v-btn @click="downloadBD">excel出力</v-btn>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="事業本部"
                url="/divisions/kv?type=BU"
                v-model="buId"
              />
            </v-flex>
          </v-card-actions>
          <v-data-table
            :headers="blHeaders"
            :items="showBlDirectors"
            :rows-per-page-items="[10]"
            class="elevation-0"
            item-key="key"
            select-all
            v-model="blSelected"
            :pagination.sync="blPagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{
                  props.item.buCode === null
                    ? ""
                    : props.item.buCode + ":" + props.item.buName
                }}
              </td>
              <td>
                {{
                  props.item.departmentCode === null
                    ? ""
                    : props.item.departmentCode +
                      ":" +
                      props.item.departmentName
                }}
              </td>
              <td>{{ props.item.productName }}</td>
              <td>
                {{
                  props.item.classificationName == null
                    ? classificationMapper(props.item.classificationId)
                    : props.item.classificationName
                }}
              </td>
              <td>{{ props.item.blDirector1Name }}</td>
              <td>{{ props.item.blDirector2Name }}</td>
              <td>{{ props.item.blDirector3Name }}</td>
              <td>{{ props.item.blDirector4Name }}</td>
              <td>{{ props.item.blDirector5Name }}</td>
              <td>{{ props.item.blDirector6Name }}</td>
              <td>{{ props.item.blDirector7Name }}</td>
              <td>{{ props.item.blDirector8Name }}</td>
            </template>
          </v-data-table>
          <sharp-bl-dialog
            :accRepeat="accRepeatFunc('BL_Director')"
            :companyId="company.companyId"
            @refresh="saved()"
            ref="bl"
          ></sharp-bl-dialog>
          <sharp-bl-edit
            :acc="blSelected[0]"
            :accRepeat="accRepeatFunc('BL_Director', blSelected[0])"
            :companyId="company.companyId"
            @blEdit="blEdit"
            @refresh="saved()"
            ref="blEdit"
          ></sharp-bl-edit>
        </v-card>
      </v-tab-item>
      <v-tab>倉庫別指示者設定</v-tab>
      <v-tab-item>
        <v-card class="mt-2">
          <v-card-title>倉庫別指示者設定</v-card-title>
          <v-card-actions>
            <v-flex md1 sm6 xs12>
              <v-btn @click="createWarehouseDelivery()">行追加</v-btn></v-flex
            >
            <v-flex md1 sm6 xs12>
              <v-btn
                :disabled="selected.length !== 1"
                @click="editWarehouseDelivery()"
                >編集</v-btn
              >
            </v-flex>
            <v-flex md1 sm6 xs12>
              <v-btn :disabled="selected.length !== 1" @click="remove">{{
                $t("app.buttons.remove")
              }}</v-btn>
            </v-flex>

            <v-flex md2 sm6 xs12>
              <v-btn @click="downloadBD">excel出力</v-btn>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="事業本部"
                url="/divisions/kv?type=BU"
                v-model="buId"
              />
            </v-flex>
          </v-card-actions>
          <v-data-table
            :headers="warehouseDeliveryHeaders"
            :items="showWarehouseDeliveryDirectors"
            :rows-per-page-items="[10]"
            class="elevation-0"
            item-key="key"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{
                  props.item.buCode === null
                    ? ""
                    : props.item.buCode + ":" + props.item.buName
                }}
              </td>
              <td>
                {{ props.item.businessUnitName }}
              </td>
              <td>{{ props.item.deliveryDirectorName1 }}</td>
              <td>{{ props.item.deliveryDirectorName2 }}</td>
              <td>{{ props.item.deliveryDirectorName3 }}</td>
              <td>{{ props.item.deliveryDirectorName4 }}</td>
              <td>{{ props.item.deliveryDirectorName5 }}</td>
              <td>{{ props.item.deliveryDirectorName6 }}</td>
              <td>{{ props.item.deliveryDirectorName7 }}</td>
              <td>{{ props.item.deliveryDirectorName8 }}</td>
            </template>
          </v-data-table>
          <sharp-warehouse-delivery-dialog
            :accRepeat="accRepeatFunc('Warehouse_Delivery_Director')"
            :companyId="company.companyId"
            @refresh="load"
            ref="warehouseDelivery"
          >
          </sharp-warehouse-delivery-dialog>
          <sharp-warehouse-delivery-edit-dialog
            :acc="selected[0]"
            :accRepeat="
              accRepeatFunc('Warehouse_Delivery_Director', selected[0])
            "
            :companyId="company.companyId"
            @refresh="load"
            ref="warehouseDeliveryEdit"
          >
          </sharp-warehouse-delivery-edit-dialog>
        </v-card>
      </v-tab-item>
      <v-tab>着荷計画書受信者設定</v-tab>
      <v-tab-item>
        <v-card class="mt-2">
          <v-card-title>着荷計画書受信者設定</v-card-title>
          <v-card-actions>
            <v-flex md1 sm6 xs12>
              <v-btn
                :disabled="selected.length !== 1"
                @click="editSytcDirectors()"
                >編集</v-btn
              >
            </v-flex>
          </v-card-actions>
          <v-data-table
            :headers="sytcMailHeaders"
            :items="showSytcMailDirectors"
            :rows-per-page-items="[10]"
            class="elevation-0"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{
                  props.item.buCode === null
                    ? ""
                    : props.item.buCode + ":" + props.item.buName
                }}
              </td>
              <td>{{ props.item.deliveryDirectorName1 }}</td>
              <td>{{ props.item.deliveryDirectorName2 }}</td>
              <td>{{ props.item.deliveryDirectorName3 }}</td>
              <td>{{ props.item.deliveryDirectorName4 }}</td>
              <td>{{ props.item.deliveryDirectorName5 }}</td>
              <td>{{ props.item.deliveryDirectorName6 }}</td>
              <td>{{ props.item.deliveryDirectorName7 }}</td>
              <td>{{ props.item.deliveryDirectorName8 }}</td>
              <td>{{ props.item.deliveryDirectorName9 }}</td>
              <td>{{ props.item.deliveryDirectorName10 }}</td>
            </template>
          </v-data-table>
          <sharp-sytc-mail-edit-dialog
            :acc="selected[0]"
            :accRepeat="accRepeatFunc('Sytc_Mail_Director', selected[0])"
            :companyId="company.companyId"
            @refresh="load"
            ref="sytcDirectorEdit"
          ></sharp-sytc-mail-edit-dialog>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import SharpDialog from "./SharpDialog";
import SharpBlDialog from "./SharpBlDialog";
import SharpWarehouseDeliveryDialog from "./WarehouseDeliveryDialog";
import SharpBlEdit from "./SharpBlEdit";
import SharpEdit from "./SharpEdit";
import SharpWarehouseDeliveryEditDialog from "./WarehouseDeliveryEditDialog";
import SharpSytcMailEditDialog from "./SytcMailEditDialog";

export default {
  components: {
    SharpDialog,
    SharpBlDialog,
    SharpBlEdit,
    SharpEdit,
    SharpWarehouseDeliveryDialog,
    SharpWarehouseDeliveryEditDialog,
    SharpSytcMailEditDialog,
  },
  props: ["company"],
  data() {
    return {
      showDeliveryDirectors: [],
      showBlDirectors: [],
      showWarehouseDeliveryDirectors: [],
      showSytcMailDirectors: [],
      buId: null,
      departmentId: null,
      headers: this.$store.state.deliveryDirectorHeader,
      blHeaders: [
        { text: "事業本部", value: "buId", sortable: true },
        { text: "事業部", value: "departmentId", sortable: true },
        { text: "品種", value: "productCode", sortable: false },
        { text: "部品区分", value: "classification", sortable: false },
        { text: "B/L確認担当1", value: "blDirectorId1", sortable: false },
        { text: "B/L確認担当2", value: "blDirectorId2", sortable: false },
        { text: "B/L確認担当3", value: "blDirectorId3", sortable: false },
        { text: "B/L確認担当4", value: "blDirectorId3", sortable: false },
        { text: "B/L確認担当5", value: "blDirectorId3", sortable: false },
        { text: "B/L確認担当6", value: "blDirectorId3", sortable: false },
        { text: "B/L確認担当7", value: "blDirectorId3", sortable: false },
        { text: "B/L確認担当8", value: "blDirectorId3", sortable: false },
      ],
      warehouseDeliveryHeaders: [
        { text: "事業本部", value: "buId", sortable: true },
        { text: "BU", value: "businessUnitId", sortable: true },
        {
          text: "倉庫別納入指示担当1",
          value: "blDirectorId1",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当2",
          value: "blDirectorId2",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当3",
          value: "blDirectorId3",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当4",
          value: "blDirectorId3",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当5",
          value: "blDirectorId3",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当6",
          value: "blDirectorId3",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当7",
          value: "blDirectorId3",
          sortable: false,
        },
        {
          text: "倉庫別納入指示担当8",
          value: "blDirectorId3",
          sortable: false,
        },
      ],
      sytcMailHeaders: [
        { text: "事業本部", value: "buId", sortable: false },
        {
          text: "着荷計画書受信担当1",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当2",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当3",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当4",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当5",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当6",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当7",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当8",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当9",
          value: "",
          sortable: false,
        },
        {
          text: "着荷計画書受信担当10",
          value: "",
          sortable: false,
        },
      ],
      selected: [],
      blSelected: [],
      pagination: {
        rowsPerPage: 10,
        page: 1,
      },
      blPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      ddHeaders: [
        { text: "企业Code", value: "companyCode" },
        { text: "企业Name", value: "companyName" },
        { text: "事業本部Code", value: "buCode" },
        { text: "事業本部Name", value: "buName" },
        { text: "事業部Code", value: "departmentCode" },
        { text: "事業部Name", value: "departmentName" },
        { text: "品種Code", value: "productCode" },
        { text: "品種Name", value: "productName" },
        { text: "部品区分", value: "classificationName" },
        { text: "納入指示担当1Code", value: "deliveryDirectorCode1" },
        { text: "納入指示担当1Name", value: "deliveryDirectorName1" },
        { text: "納入指示担当2Code", value: "deliveryDirectorCode2" },
        { text: "納入指示担当2Name", value: "deliveryDirectorName2" },
        { text: "納入指示担当3Code", value: "deliveryDirectorCode3" },
        { text: "納入指示担当3Name", value: "deliveryDirectorName3" },
        { text: "納入指示担当4Code", value: "deliveryDirectorCode4" },
        { text: "納入指示担当4Name", value: "deliveryDirectorName4" },
        { text: "納入指示担当5Code", value: "deliveryDirectorCode5" },
        { text: "納入指示担当5Name", value: "deliveryDirectorName5" },
        { text: "納入指示担当6Code", value: "deliveryDirectorCode6" },
        { text: "納入指示担当6Name", value: "deliveryDirectorName6" },
        { text: "納入指示担当7Code", value: "deliveryDirectorCode7" },
        { text: "納入指示担当7Name", value: "deliveryDirectorName7" },
        { text: "納入指示担当8Code", value: "deliveryDirectorCode8" },
        { text: "納入指示担当8Name", value: "deliveryDirectorName8" },
      ],
      bdHeaders: [
        { text: "企业Code", value: "companyCode" },
        { text: "企业Name", value: "companyName" },
        { text: "事業本部Code", value: "buCode" },
        { text: "事業本部Name", value: "buName" },
        { text: "事業部Code", value: "departmentCode" },
        { text: "事業部Name", value: "departmentName" },
        { text: "品種Code", value: "productCode" },
        { text: "品種Name", value: "productName" },
        { text: "部品区分", value: "classificationName" },
        { text: "B/L確認担当1Code", value: "blDirectorCode1" },
        { text: "B/L確認担当1Name", value: "blDirectorName1" },
        { text: "B/L確認担当2Code", value: "blDirectorCode2" },
        { text: "B/L確認担当2Name", value: "blDirectorName2" },
        { text: "B/L確認担当3Code", value: "blDirectorCode3" },
        { text: "B/L確認担当3Name", value: "blDirectorName3" },
        { text: "B/L確認担当4Code", value: "blDirectorCode4" },
        { text: "B/L確認担当4Name", value: "blDirectorName4" },
        { text: "B/L確認担当5Code", value: "blDirectorCode5" },
        { text: "B/L確認担当5Name", value: "blDirectorName5" },
        { text: "B/L確認担当6Code", value: "blDirectorCode6" },
        { text: "B/L確認担当6Name", value: "blDirectorName6" },
        { text: "B/L確認担当7Code", value: "blDirectorCode7" },
        { text: "B/L確認担当7Name", value: "blDirectorName7" },
        { text: "B/L確認担当8Code", value: "blDirectorCode8" },
        { text: "B/L確認担当8Name", value: "blDirectorName8" },
      ],
    };
  },
  methods: {
    edit() {
      this.$refs.edit.popup(this.company.companyId, this.selected[0].id);
    },
    editWarehouseDelivery() {
      this.$refs.warehouseDeliveryEdit.popup(
        this.company.companyId,
        this.selected[0].id
      );
    },
    editSytcDirectors() {
      this.$refs.sytcDirectorEdit.popup(
        this.company.companyId,
        this.selected[0].id
      );
    },
    editBl() {
      this.$refs.blEdit.popup(this.company.companyId, this.blSelected[0].id);
    },
    blEdit(item) {
      var blData = {};
      this.initBlData(item, blData);
      if (item) {
        this.$set(this.company.accs, "BL_Director", [
          ...this.company.accs.BL_Director,
          { ...blData, key: new Date().getTime() },
        ]);
        this.$emit("updateBlDirector", this.company);
      }
    },
    classificationMapper(item) {
      if (!item) return "";
      switch (item) {
        case 1:
          return "完成品";
        case 2:
          return "部件";
        case 3:
          return "サービスパーツ";
        default:
          return "その他";
      }
    },
    buChange() {},
    saved() {
      this.pagination.page = 1;
      this.load();
    },
    load() {
      this.selected = [];
      this.blSelected = [];
      this.$emit("refresh");
    },
    addNew(item) {
      var data = {};
      if (item.bu != null) {
        data = { ...data, buId: item.bu.value, buName: item.bu.text };
      }
      if (item.department != null) {
        data = {
          ...data,
          departmentId: item.department.value,
          departmentName: item.department.text,
        };
      }
      if (item.product != null) {
        data = {
          ...data,
          productCode: item.product.value,
          productName: item.product.text,
        };
      }
      if (item.classification != null) {
        data = {
          ...data,
          classificationId: item.classification.value,
          classificationName: item.classification.text,
        };
      }
      if (item.deliveryDirectorId1 != null) {
        data = {
          ...data,
          deliveryDirectorId1: item.deliveryDirectorId1.value,
          deliveryDirectorName1: item.deliveryDirectorId1.text,
        };
      }
      if (item.deliveryDirectorId2 != null) {
        data = {
          ...data,
          deliveryDirectorId2: item.deliveryDirectorId2.value,
          deliveryDirectorName2: item.deliveryDirectorId2.text,
        };
      }
      if (item.deliveryDirectorId3 != null) {
        data = {
          ...data,
          deliveryDirectorId3: item.deliveryDirectorId3.value,
          deliveryDirectorName3: item.deliveryDirectorId3.text,
        };
      }
      if (item.deliveryDirectorId4 != null) {
        data = {
          ...data,
          deliveryDirectorId4: item.deliveryDirectorId4.value,
          deliveryDirectorName4: item.deliveryDirectorId4.text,
        };
      }
      if (item.deliveryDirectorId5 != null) {
        data = {
          ...data,
          deliveryDirectorId5: item.deliveryDirectorId5.value,
          deliveryDirectorName5: item.deliveryDirectorId5.text,
        };
      }
      if (item) {
        if (this.accRepeat("Delivery_Director", item)) return;
        this.company.accs.Delivery_Director.push({
          ...data,
          key: new Date().getTime(),
        });
      }
    },

    accRepeatFunc(key, excludeItem) {
      return (acc) => {
        return this.accRepeat(key, acc, excludeItem);
      };
    },
    accRepeat(key, item, excludeItem) {
      function itemEqual(a, b) {
        a = a || null;
        b = b || null;
        return a === b;
      }
      console.log(this.company.accs[key]);
      console.log(this.company.accs[key].filter((i) => i === null));
      console.log(
        this.company.accs[key].filter((i) => {
          return !excludeItem ? true : i.id != excludeItem.id;
        })
      );
      let flag =
        this.company.accs[key]
          .filter((i) => {
            return !excludeItem ? true : i.id != excludeItem.id;
          })
          .filter((i) => itemEqual(i.buId, item.bu ? item.bu.value : null))
          .filter((i) =>
            itemEqual(
              i.businessUnitId,
              item.businessUnitId ? item.businessUnitId.value : null
            )
          )
          .filter((i) =>
            itemEqual(
              i.departmentId,
              item.department ? item.department.value : null
            )
          )
          .filter((i) =>
            itemEqual(i.productCode, item.product ? item.product.value : null)
          )
          .filter((i) =>
            itemEqual(
              i.productGroupName,
              item.productGroupName ? item.productGroupName.value : null
            )
          )
          .filter((i) =>
            itemEqual(
              i.classificationId,
              item.classification ? item.classification.value : null
            )
          ).length > 0;

      if (flag) {
        this.$message("", "重複キーを追加できません");
      }
      return flag;
    },
    initBlData(item, blData) {
      if (item.bu != null) {
        blData = { ...blData, buId: item.bu.value, buName: item.bu.text };
      }
      if (item.department != null) {
        blData = {
          ...blData,
          departmentId: item.department.value,
          departmentName: item.department.text,
        };
      }
      if (item.product != null) {
        blData = {
          ...blData,
          productCode: item.product.value,
          productName: item.product.text,
        };
      }
      if (item.blDirector1Id != null) {
        blData = {
          ...blData,
          blDirector1Id: item.blDirector1Id.value,
          blDirector1Name: item.blDirector1Id.text,
        };
      }
      if (item.blDirector2Id != null) {
        blData = {
          ...blData,
          blDirector2Id: item.blDirector2Id.value,
          blDirector2Name: item.blDirector2Id.text,
        };
      }
      if (item.blDirector3Id != null) {
        blData = {
          ...blData,
          blDirector3Id: item.blDirector3Id.value,
          blDirector3Name: item.blDirector3Id.text,
        };
      }
      if (item.classification != null) {
        blData = {
          ...blData,
          classificationId: item.classification.value,
          classificationName: item.classification.text,
        };
      }
      return blData;
    },
    remove() {
      this.$confirm({ content: this.$t("app.messages.removeConfirm") }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/companies/${s.id}/delete-sharp-acc`);
            })
          ).then(() => {
            this.selected = [];
            this.load();
            this.$message("", "削除成功");
          });
        }
      );
    },
    removeBl() {
      this.$confirm({ content: this.$t("app.messages.removeConfirm") }).then(
        () => {
          Promise.all(
            this.blSelected.map((s) => {
              return this.$http.delete(`/companies/${s.id}/delete-bl-acc`);
            })
          ).then(() => {
            this.blSelected = [];
            this.load();
            this.$message("", "削除成功");
          });
        }
      );
    },
    createBl() {
      this.$refs.bl.popup();
    },
    create() {
      this.$refs.sharp.popup();
    },
    createWarehouseDelivery() {
      this.$refs.warehouseDelivery.popup();
    },
    downloadDD() {
      let headers = this.ddHeaders.map((dd) => dd.value);
      let showHeaders = this.ddHeaders.map((dd) => dd.text);
      this.$http.get("companies/delivery-director").then((res) => {
        this.$exportTable(res.data, headers, showHeaders, "DeliveryDirectors");
        console.log(res.data);
      });
    },
    downloadBD() {
      let headers = this.bdHeaders.map((dd) => dd.value);
      let showHeaders = this.bdHeaders.map((dd) => dd.text);
      this.$http.get("companies/bl-director").then((res) => {
        this.$exportTable(res.data, headers, showHeaders, "BLDirectors");
        console.log(res.data);
      });
    },
    createShowData(data) {
      if (this.buId) {
        this.$set(
          this,
          "showDeliveryDirectors",
          data.accs.Delivery_Director.filter((d) => d.buId === this.buId)
        );
        this.$set(
          this,
          "showBlDirectors",
          data.accs.BL_Director.filter((d) => d.buId === this.buId)
        );
        this.$set(
          this,
          "showWarehouseDeliveryDirectors",
          data.accs.Warehouse_Delivery_Director.filter(
            (d) => d.buId === this.buId
          )
        );
        this.$set(this, "showSytcMailDirectors", data.accs.Sytc_Mail_Director);
      } else {
        this.$set(this, "showDeliveryDirectors", data.accs.Delivery_Director);
        this.$set(this, "showBlDirectors", data.accs.BL_Director);
        this.$set(
          this,
          "showWarehouseDeliveryDirectors",
          data.accs.Warehouse_Delivery_Director
        );
        this.$set(this, "showSytcMailDirectors", data.accs.Sytc_Mail_Director);
      }
    },
  },
  mounted() {
    this.load();
  },

  watch: {
    buId() {
      this.pagination.page = 1;
      this.blPagination.page = 1;
      this.selected = [];
      this.blSelected = [];
      if (!this.buId) {
        this.showDeliveryDirectors = this.company.accs.Delivery_Director;
        this.showBlDirectors = this.company.accs.BL_Director;
        this.showWarehouseDeliveryDirectors =
          this.company.accs.Warehouse_Delivery_Director;
      } else {
        this.showDeliveryDirectors = this.company.accs.Delivery_Director.filter(
          (d) => d.buId === this.buId
        );
        this.showBlDirectors = this.company.accs.BL_Director.filter(
          (d) => d.buId === this.buId
        );
        this.showWarehouseDeliveryDirectors =
          this.company.accs.Warehouse_Delivery_Director.filter(
            (d) => d.buId === this.buId
          );
      }
    },
    pagination() {
      // this.load();
    },
  },
};
</script>
